import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

const CocoapodsIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80"><g clip-path="url(#a)"><g clip-path="url(#b)"><path fill="#FA2A00" d="M79.797 79.797H0V0h79.797v79.797Z" /><path fill="#fff" d="M50.31 42.495c-1.199 6.579-6.849 11.96-15.564 11.96-10.412 0-16.68-7.647-16.68-16.362 0-8.54 5.958-16.372 16.589-16.372 9.118 0 14.769 5.737 15.61 12.896H42.75c-.665-3.646-3.425-6.401-8.004-6.401-5.963 0-9.34 4.714-9.34 9.877 0 5.468 3.779 9.873 9.429 9.873 4.18 0 6.937-2.403 7.826-5.471h7.65Zm8.73-20.047-4.593 1.968 5.757 13.462-5.759 13.465 4.595 1.964 3.864-9.099.02.042 2.673-6.372-6.556-15.43Z" /></g></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h80v80H0z" /></clipPath><clipPath id="b"><path fill="#fff" d="M0 0h80v80H0z" /></clipPath></defs></svg>
  );
};

export default CocoapodsIcon;
